import { useTableBet, useTableBetState } from '@/hooks/useTableBet';
import { createContext } from 'react';
export const TableBetContext = createContext({} as useTableBetState);
const { Provider } = TableBetContext;
type TableBetProviderOwnProps = {
    children: JSX.Element;
    hostId: number;
};
type TableBetProviderProps = TableBetProviderOwnProps;
export const TableBetProvider = ({
    children,
    hostId,
}: TableBetProviderProps) => {
    const tb = useTableBet(hostId);
    return <Provider value={tb}>{children}</Provider>;
};
